import { IProgrammeCard } from '@studyportals/domain-client';
import { SearchStudyCardInfo } from './SearchStudyCardInfo';
import { IProgrammeResult } from '@studyportals/search-api-interface';

export class SearchResultsFactory {
	public reconstituteSearchStudyCards(programmes: IProgrammeResult<IProgrammeCard>[]): SearchStudyCardInfo[] {
		return programmes.map((record) => this.reconstituteSearchStudyCard(record));
	}

	private reconstituteSearchStudyCard(record: IProgrammeResult<IProgrammeCard>): SearchStudyCardInfo {
		return new SearchStudyCardInfo(String(record.card.getId()), record.card, record.is_premium);
	}
}
